import axios from 'axios';

const PRODUCT_SERVICE_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api/';
const AUTH_SERVICE_BASE_URL = process.env.REACT_APP_AUTH_BASE_URL || '/';

export const productService = axios.create({
  baseURL: PRODUCT_SERVICE_BASE_URL,
});

export const authService = axios.create({
  baseURL: AUTH_SERVICE_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

productService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwtToken'); // Assuming token is stored as 'jwtToken'
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

authService.interceptors.request.use(
  config => {
    const token = localStorage.getItem('jwtToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

productService.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized request (401). Token might be invalid or expired.");
    }
    return Promise.reject(error);
  }
);

authService.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.error("Unauthorized request (401). Token might be invalid or expired for Auth Service.");
    }
    return Promise.reject(error);
  }
);

export default productService;